const filterSearch = (filter_group_id, input_id) => {
    const filterSelector = '.findify-filters-checkbox-item';
    const filterTextSelector = '.findify-filters-checkbox-item-value';

    const filterGroupElement = document.getElementById(filter_group_id);
    const filters = filterGroupElement.querySelectorAll(filterSelector);
    const input = document.getElementById(input_id);

    const inputHandler = (e) => {
        const value = e.target.value.trim().toLowerCase();
        filters.forEach(item => {
            const text = item.querySelector(filterTextSelector).innerText.trim().toLowerCase();
            const shouldHide = value && !text.includes(value);
            item.setAttribute("aria-hidden", shouldHide.toString());
        });
    };

    input.addEventListener("input", inputHandler);
};

const collapseFilter = (element_id) => {
    const filterGroupElement = document.getElementById(element_id);
    const [header, body] = filterGroupElement.querySelectorAll('div');

    const headerClickHandler = (e) => {
        e.preventDefault();
        const isOpen = body.getAttribute("data-opened") === "true";
        body.setAttribute("data-opened", (!isOpen).toString());
    };

    header.addEventListener("click", headerClickHandler);
};

window.__findifyCategorySelection = window.__findifyCategorySelection || {};

const findifyNormalizeFilterValue = (value) => {
    if (value == null) return '';
    try {
        return decodeURIComponent(String(value)).trim();
    } catch (error) {
        return String(value).trim();
    }
};

const findifyIsCategoryFilter = (name, type) => {
    return String(type || '').toLowerCase() === 'category' || /^category\d+$/i.test(String(name || ''));
};

const findifyReadSelectedValues = (name) => {
    const stored = window.__findifyCategorySelection[name];
    if (Array.isArray(stored) && stored.length) return stored.slice();

    const values = [];
    const seen = {};
    const add = (raw) => {
        const normalized = findifyNormalizeFilterValue(raw);
        if (!normalized || seen[normalized]) return;
        seen[normalized] = true;
        values.push(normalized);
    };

    const state = window.findify && findify.filters && Array.isArray(findify.filters.state)
        ? findify.filters.state
        : [];

    state.forEach((item) => {
        if (!item || item.name !== name) return;
        if (Array.isArray(item.values)) {
            item.values.forEach((entry) => add(entry && typeof entry === 'object' ? entry.value : entry));
        } else {
            add(item.value);
        }
    });

    document.querySelectorAll('.findify-filters-checkbox-item[data-name]').forEach((el) => {
        if (el.getAttribute('data-name') !== name) return;
        if (String(el.getAttribute('selected')) !== 'true') return;
        add(el.getAttribute('value'));
    });

    return values;
};

const findifyToggleStoredValue = (name, value) => {
    const clicked = findifyNormalizeFilterValue(value);
    const selected = findifyReadSelectedValues(name);
    const index = selected.indexOf(clicked);
    if (index >= 0) selected.splice(index, 1);
    else if (clicked) selected.push(clicked);
    window.__findifyCategorySelection[name] = selected;
    return selected;
};

const findifyPatchStateValues = (name, selected) => {
    if (!window.findify || !Array.isArray(findify.filters && findify.filters.state)) return;

    const state = findify.filters.state;
    for (let i = state.length - 1; i >= 0; i -= 1) {
        if (state[i] && state[i].name === name) state.splice(i, 1);
    }

    if (selected.length) {
        state.push({
            name,
            type: 'category',
            values: selected.map((entry) => ({ value: entry })),
        });
    }

    if (findify.grid && findify.grid.state) {
        findify.grid.state.filters = state;
    }
};

const findifyGetSelectedCategoryMap = () => {
    const selectedByName = {};
    const add = (name, value) => {
        const key = String(name || '');
        const normalized = findifyNormalizeFilterValue(value).toLowerCase();
        if (!key || !normalized) return;
        if (!selectedByName[key]) selectedByName[key] = {};
        selectedByName[key][normalized] = true;
    };

    Object.keys(window.__findifyCategorySelection || {}).forEach((name) => {
        (window.__findifyCategorySelection[name] || []).forEach((value) => add(name, value));
    });

    const state = window.findify && findify.filters && Array.isArray(findify.filters.state)
        ? findify.filters.state
        : [];
    state.forEach((item) => {
        if (!item || !findifyIsCategoryFilter(item.name, item.type)) return;
        const values = Array.isArray(item.values) ? item.values : [{ value: item.value }];
        values.forEach((entry) => add(item.name, entry && typeof entry === 'object' ? entry.value : entry));
    });

    document.querySelectorAll('.findify-filters-breadcrumb-item').forEach((el) => {
        const name = el.getAttribute('data-name') || el.getAttribute('name');
        const type = el.getAttribute('data-type') || el.getAttribute('type');
        if (!findifyIsCategoryFilter(name, type)) return;
        add(name, el.getAttribute('value'));
        add(name, el.textContent);
    });

    return selectedByName;
};

const findifyIsValueSelected = (selectedByName, name, value) => {
    const normalized = findifyNormalizeFilterValue(value).toLowerCase();
    if (!normalized) return false;
    if (selectedByName[name] && selectedByName[name][normalized]) return true;
    return Object.keys(selectedByName).some((storedName) => {
        return findifyIsCategoryFilter(storedName) && selectedByName[storedName][normalized];
    });
};

const findifySyncCategoryCheckboxes = () => {
    const selectedByName = findifyGetSelectedCategoryMap();

    document.querySelectorAll('.findify-filters-checkbox-item[data-name]').forEach((el) => {
        const name = el.getAttribute('data-name');
        const type = el.getAttribute('data-type');
        if (!findifyIsCategoryFilter(name, type)) return;

        const isSelected = findifyIsValueSelected(selectedByName, name, el.getAttribute('value'))
            || findifyIsValueSelected(
                selectedByName,
                name,
                (el.querySelector('.findify-filters-checkbox-item-value span, .findify-filters--checkbox-nested-value span') || {}).textContent
            );
        el.setAttribute('selected', isSelected ? 'true' : 'false');

        const label = el.querySelector('.findify-filters-checkbox-item-value, .findify-filters--checkbox-nested-value');
        if (!label) return;
        label.classList.toggle('findify-filters-checkbox-item-value-selected', isSelected);
        label.classList.toggle('findify-filters--checkbox-nested-value-selected', isSelected);
    });
};

const findifyScheduleCheckboxSync = () => {
    findifySyncCategoryCheckboxes();
    requestAnimationFrame(findifySyncCategoryCheckboxes);
    setTimeout(findifySyncCategoryCheckboxes, 50);
    setTimeout(findifySyncCategoryCheckboxes, 250);
    setTimeout(findifySyncCategoryCheckboxes, 600);
};

const findifyInstallLoadGate = () => {
    if (!window.findify || !findify.grid || typeof findify.grid.load !== 'function') return;
    if (findify.grid.load.__findifyGated) return;

    const originalLoad = findify.grid.load.bind(findify.grid);
    findify.grid.__findifySkipLoad = 0;
    findify.grid.__findifyOriginalLoad = originalLoad;

    const gatedLoad = function (...args) {
        if (findify.grid.__findifySkipLoad > 0) {
            findify.grid.__findifySkipLoad -= 1;
            return Promise.resolve();
        }
        if (findify.grid.state && findify.filters) {
            findify.grid.state.filters = findify.filters.state;
        }
        const result = originalLoad(...args);
        if (result && typeof result.then === 'function') {
            return result.then((response) => {
                findifyScheduleCheckboxSync();
                return response;
            });
        }
        findifyScheduleCheckboxSync();
        return result;
    };
    gatedLoad.__findifyGated = true;
    findify.grid.load = gatedLoad;

    if (typeof findify.grid.api === 'function' && !findify.grid.api.__findifyGated) {
        const originalApi = findify.grid.api.bind(findify.grid);
        const gatedApi = function (request, ...rest) {
            if (request && typeof request === 'object' && findify.filters) {
                request.filters = findify.filters.state;
            }
            return originalApi(request, ...rest);
        };
        gatedApi.__findifyGated = true;
        findify.grid.api = gatedApi;
    }
};

const findifyApplyCategorySelection = ({ name, type, value }) => {
    if (!window.findify || !findify.filters || typeof findify.filters.update !== 'function') return;

    const selected = findifyToggleStoredValue(name, value);
    const originalUpdate = findify.filters.__findifyOriginalUpdate || findify.filters.update.bind(findify.filters);

    findifyInstallLoadGate();
    findify.grid.__findifySkipLoad = (findify.grid.__findifySkipLoad || 0) + 1;

    originalUpdate({
        name,
        type: 'text',
        value: findifyNormalizeFilterValue(value),
    }, true);

    findifyPatchStateValues(name, selected);
    findifySyncCategoryCheckboxes();

    const reload = typeof findify.grid.__findifyOriginalLoad === 'function'
        ? findify.grid.__findifyOriginalLoad()
        : (findify.grid && typeof findify.grid.load === 'function' ? findify.grid.load() : null);

    if (reload && typeof reload.then === 'function') {
        return reload.then((response) => {
            findifyScheduleCheckboxSync();
            return response;
        });
    }

    findifyScheduleCheckboxSync();
    return reload;
};

const findifyWrapFilterUpdate = () => {
    if (!window.findify || !findify.filters || typeof findify.filters.update !== 'function') return false;
    if (findify.filters.update.__findifyMultiSelect) return true;

    const originalUpdate = findify.filters.update.bind(findify.filters);
    findify.filters.__findifyOriginalUpdate = originalUpdate;

    const wrappedUpdate = function (filter, ...args) {
        if (filter && findifyIsCategoryFilter(filter.name, filter.type)) {
            return findifyApplyCategorySelection(filter);
        }
        return originalUpdate(filter, ...args);
    };
    wrappedUpdate.__findifyMultiSelect = true;
    findify.filters.update = wrappedUpdate;

    if (typeof findify.filters.reset === 'function' && !findify.filters.reset.__findifyMultiSelect) {
        const originalReset = findify.filters.reset.bind(findify.filters);
        const wrappedReset = function (...args) {
            window.__findifyCategorySelection = {};
            const result = originalReset(...args);
            findifyScheduleCheckboxSync();
            return result;
        };
        wrappedReset.__findifyMultiSelect = true;
        findify.filters.reset = wrappedReset;
    }

    return true;
};

const findifyHandleCategoryClick = (event) => {
    const checkbox = event.target.closest && event.target.closest('.findify-filters-checkbox-item');
    const breadcrumb = event.target.closest && event.target.closest('.findify-filters-breadcrumb-item');
    const item = checkbox || breadcrumb;
    if (!item) return;

    const name = item.getAttribute('data-name') || item.getAttribute('name');
    const type = item.getAttribute('data-type') || item.getAttribute('type');
    const value = item.getAttribute('value');
    if (!findifyIsCategoryFilter(name, type)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    findifyWrapFilterUpdate();
    findifyApplyCategorySelection({ name, type, value });
};

if (!window.__findifyCategoryClickBound) {
    window.__findifyCategoryClickBound = true;
    window.addEventListener('click', findifyHandleCategoryClick, true);
    window.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        findifyHandleCategoryClick(event);
    }, true);
}

const bootFindifyCategoryMultiSelect = () => {
    if (findifyWrapFilterUpdate()) return;
    const startedAt = Date.now();
    const timer = setInterval(() => {
        if (findifyWrapFilterUpdate() || Date.now() - startedAt > 20000) {
            clearInterval(timer);
        }
    }, 50);
};

const findifyObserveFilterSidebar = () => {
    if (window.__findifyCategoryObserverBound || typeof MutationObserver === 'undefined') return;
    const root = document.getElementById('findify-filters') || document.querySelector('.findify-filters-sidebar') || document.body;
    if (!root) return;
    window.__findifyCategoryObserverBound = true;
    const observer = new MutationObserver(() => findifyScheduleCheckboxSync());
    observer.observe(root, { childList: true, subtree: true });
};

if (window.findify && findify.core && findify.core.init && typeof findify.core.init.then === 'function') {
    findify.core.init.then(() => {
        bootFindifyCategoryMultiSelect();
        findifyObserveFilterSidebar();
        findifyScheduleCheckboxSync();
    });
} else {
    bootFindifyCategoryMultiSelect();
    findifyObserveFilterSidebar();
    findifyScheduleCheckboxSync();
}

window.findifyApplyCategorySelection = findifyApplyCategorySelection;
window.findifyWrapFilterUpdate = findifyWrapFilterUpdate;
window.findifySyncCategoryCheckboxes = findifySyncCategoryCheckboxes;
